<script>
export default {
    name: "login-password-field",
    data() {
        return {
            showPw: false
        }
    },
    computed: {
        tPassword() { return Lang.langGet('Password') },
        rules() {
            return {
                password: (value) => {
                    if (!value) {
                        this.$emit('valid', 'password', false);
                        return Lang.langGet('You must enter an ') + 'Password';
                    }

                    this.$emit('valid', 'password', true);
                    return true;
                }
            }
        }
    }
}
</script>

<template>
    <v-text-field
        aria-label="password" type="password" name="password"
        :placeholder="tPassword"
        :rules="[rules.password]"
        required outlined dense
        :type="showPw ? 'text' : 'password'"
        :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPw = !showPw"
    />
</template>
